import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "h-7-5 pt-0.5 text-sm w-8 px-1" }

import { useStore } from "@/stores/game";
import { computed } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'gameRound',
  props: {
  round: {
    type: Object,
    required: true,
  },
  roundIndex: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props



const game = useStore();
const isActive = computed(() => {
  return props.roundIndex == game.firstActiveRound;
});

const totalPrediction = computed(() => {
  return game.sumOfpredictionInRound(props.roundIndex) == 0 ? "" : game.sumOfpredictionInRound(props.roundIndex);
});

const exceedance = computed(() => {
    if(props.round.id != 1){
        return totalPrediction.value >= props.round.id;
    } else {
        return false
    }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["flex flex-row gap-2", {'bg-blue-100': _unref(isActive)}])
  }, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.round.id), 1),
    _createElementVNode("div", {
      class: _normalizeClass(["h-7-5 pt-0.5 text-sm px-1", {'bg-red': _unref(exceedance)}])
    }, _toDisplayString(_unref(totalPrediction)), 3)
  ], 2))
}
}

})